import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-90c3ac0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mas-table-pagination" }

import { getCurrentInstance, ref, reactive } from "vue";
import _ from "lodash";
interface IPageConfig {
  total: number;
  current: number;
  pageSize: number;
}

const __default__ = { name: "MasTablePagination" };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  list: {
    type: Array as () => any[],
    default: [],
  },
  pageConfig: {
    type: Object as () => IPageConfig,
    default: {}
  },
  hideOnSinglePage: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const { proxy } = getCurrentInstance() as any;

const state = reactive({
  pageSize: [10, 20, 30, 40, 50, 100, 200]
})
const _pageChange = (v: number) => {
  proxy.$emit("pageChange", v);
};
const _handleSizeChange = (v: number) => {
  proxy.$emit("sizeChange", v);
}

return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "table", { content: __props.list }),
    (!_unref(_).isEmpty(__props.pageConfig))
      ? (_openBlock(), _createBlock(_component_el_pagination, {
          key: 0,
          class: "common-pagination",
          layout: "total, sizes, prev, pager, next, jumpers",
          "hide-on-single-page": __props.hideOnSinglePage,
          total: __props.pageConfig.total,
          "page-size": __props.pageConfig.pageSize,
          "onUpdate:page-size": _cache[0] || (_cache[0] = ($event: any) => ((__props.pageConfig.pageSize) = $event)),
          "page-sizes": _unref(state).pageSize,
          currentPage: __props.pageConfig.current,
          "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((__props.pageConfig.current) = $event)),
          onCurrentChange: _pageChange,
          onSizeChange: _handleSizeChange
        }, null, 8, ["hide-on-single-page", "total", "page-size", "page-sizes", "currentPage"]))
      : _createCommentVNode("", true)
  ]))
}
}

})